import { TEST_SEGMENTS, TEST_SEGMENT_TO_PAGES_SEGMENT } from 'root-constants'
import { TStepsSegmentName, TStepsVariant } from 'root-types'

export const FALLBACK_STEPS_SEGMENT_NAME: TStepsSegmentName =
  TEST_SEGMENTS.VARIANT_A

const STEPS_SEGMENT_NAMES = Object.values(TEST_SEGMENTS) as TStepsSegmentName[]

export const isStepsSegmentName = (value: string): value is TStepsSegmentName =>
  STEPS_SEGMENT_NAMES.includes(value as TStepsSegmentName)

export const getStepsVariantFromSegmentName = (
  value: TStepsSegmentName,
): TStepsVariant => TEST_SEGMENT_TO_PAGES_SEGMENT[value]
